import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { SettingsState } from '@app/_state/settings.state';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UpdateReturnUrlAction } from '@app/_state/settings.actions';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private store = inject(Store);
  private router = inject(Router);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const jwtHelper = new JwtHelperService();
    const isAuthenticated = this.store.selectSnapshot(SettingsState.isAuthenticated);
    const token = this.store.selectSnapshot(SettingsState.token);
    const isTokenExpired = jwtHelper.isTokenExpired(token as string);
    if (!isAuthenticated || isTokenExpired) {
      console.log('isAuthenticated', isAuthenticated);
      this.store.dispatch(new UpdateReturnUrlAction({returnUrl: state.url}));
      this.router.navigate(['/logout']);
    }
    return isAuthenticated;
  }

}
